import { WorkspaceUntypedData } from "@supernova-studio/model";
import { z } from "zod";
//
// Read
//
export const DTOWorkspaceUntypedData = WorkspaceUntypedData;
export const DTOWorkspaceUntypedDataListResponse = z.object({
    data: DTOWorkspaceUntypedData.array(),
});
export const DTOWorkspaceUntypedDataResponse = z.object({
    data: DTOWorkspaceUntypedData,
});
//
// Write
//
export const DTOWorkspaceUntypedDataCreatePayload = z.object({
    value: z.unknown(),
});
export const DTOWorkspaceUntypedDataUpdatePayload = z.object({
    value: z.unknown(),
});
